import React, { useEffect, useRef, useState } from "react";
import { NavLink as NavLinkRRD, Link, useHistory, useLocation } from "react-router-dom";
import { PropTypes } from "prop-types";
import Logo from "../../assets/img/custom/logo.png";
import { logout, switchLayout } from "../../store/actions/authActions";
import { getUnreadNotifications } from "store/actions/notificationsAction";
import { FaBell, FaUserCircle } from "react-icons/fa";
import {
  Button,
  Collapse,
  Modal,
  ModalBody,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import AthletePromotionModal from "../Modals/AthletePromotionModal";

const Sidebar = (props) => {
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [logoutModal, setLogoutModal] = useState(false);
  const [selfBoostModal, setSelfBoostModal] = useState(false);
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [showDot, setShowDot] = useState(false);

  const profileDropdownRef = useRef(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const { user, isManager, uid } = useSelector((state) => state.auth);
  const { unreadNotifications } = useSelector((state) => state.notifications);

  const logoutToggle = () => setLogoutModal((v) => !v);
  const toggleSelfBoostModal = () => setSelfBoostModal((v) => !v);

  useEffect(() => {
    if (user?.id) {
      dispatch(getUnreadNotifications(user.id, "", () => {}));
    }
  }, []);

  useEffect(() => {
    if (
      location.pathname !== "/fan/notifications" &&
      unreadNotifications?.length > 0
    ) {
      setShowDot(true);
    }
  }, [unreadNotifications, location.pathname]);

  useEffect(() => {
    if (location.pathname === "/fan/notifications") {
      setShowDot(false);
    }
  }, [location.pathname]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        profileDropdownRef.current &&
        !profileDropdownRef.current.contains(e.target)
      ) {
        setProfileDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleBellClick = () => {
    setShowDot(false);
    history.push("/fan/notifications");
  };

  const activeRoute = (routeName) =>
    props.location.pathname.indexOf(routeName) > -1 ? "active" : "";

  const toggleCollapse = () => setCollapseOpen((v) => !v);
  const closeCollapse = () => setCollapseOpen(false);

  const createLinks = (routes) =>
    routes.map((prop, key) => {
      if (prop.layout === "/fan" && prop.showInMenu && !isManager) {
        return (
          <NavItem key={key}>
            <NavLink
              to={prop.layout + prop.path}
              tag={NavLinkRRD}
              onClick={closeCollapse}
              activeClassName="active"
            >
              <span className="boldClass">{prop.name}</span>
            </NavLink>
          </NavItem>
        );
      } else if (prop.layout === "/manager" && prop.showInMenu && isManager) {
        return (
          <NavItem key={key}>
            <NavLink
              to={prop.layout + prop.path}
              tag={NavLinkRRD}
              onClick={closeCollapse}
              activeClassName="active"
            >
              <span className="boldClass">{prop.name}</span>
            </NavLink>
          </NavItem>
        );
      }
      return null;
    });

  const { routes, logo } = props;

  return (
    <>
      <Navbar
        className="navbar-vertical fixed-left navbar-light bg-primary custom-sidebar"
        expand="lg"
        id="sidenav-main"
        style={{ top: props.maxLimitReached ? "30px" : "0px" }}
      >
        <Container fluid>
          {/* ── Mobile top bar: hamburger + bell + profile ── */}
          <div className="d-flex d-lg-none align-items-center w-100">
            {/* Hamburger */}
            <button
              className="navbar-toggler navbar-dark p-0 mr-auto"
              type="button"
              style={{ color: "white", border: "none", background: "none" }}
              onClick={toggleCollapse}
            >
              <span className="navbar-toggler-icon" />
            </button>

            {/* Bell */}
            <div
              onClick={handleBellClick}
              className="position-relative mr-3"
              style={{ cursor: "pointer" }}
            >
              <FaBell size={22} color="white" />
              {showDot && (
                <span
                  className="position-absolute bg-danger rounded-circle blinking-dot"
                  style={{
                    width: "9px",
                    height: "9px",
                    top: "-4px",
                    right: "-4px",
                    zIndex: 1,
                  }}
                />
              )}
            </div>

            {/* Profile icon */}
            <div className="position-relative" ref={profileDropdownRef}>
              <div
                style={{ cursor: "pointer" }}
                onClick={() => setProfileDropdownOpen((v) => !v)}
              >
                {user?.photo || user?.photoURL ? (
                  <img
                    src={user.photo || user.photoURL}
                    alt="profile"
                    style={{
                      width: "34px",
                      height: "34px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      border: "2px solid rgba(255,255,255,0.7)",
                    }}
                  />
                ) : (
                  <FaUserCircle size={32} color="white" />
                )}
              </div>

              {/* Dropdown */}
              {profileDropdownOpen && (
                <div
                  style={{
                    position: "absolute",
                    right: 0,
                    top: "42px",
                    background: "#fff",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.18)",
                    minWidth: "150px",
                    zIndex: 9999,
                  }}
                >
                  {(user?.isManager && (user?.managerCertified || user?.certifiedFromExternalPlatform)) && (
                    <>
                      <button
                        style={dropdownItemStyle}
                        onClick={() => {
                          setProfileDropdownOpen(false);
                          toggleSelfBoostModal();
                        }}
                      >
                        Self Boost
                      </button>
                      <hr style={{ margin: 0 }} />
                      <button
                        style={dropdownItemStyle}
                        onClick={() => {
                          setProfileDropdownOpen(false);
                          dispatch(switchLayout(!isManager));
                        }}
                      >
                        {isManager ? "Fan" : "Manager"}
                      </button>
                      <hr style={{ margin: 0 }} />
                    </>
                  )}
                  <a
                    href="mailto:FansHelpPlayers@gmail.com"
                    style={{ ...dropdownItemStyle, textDecoration: "none" }}
                    onClick={() => setProfileDropdownOpen(false)}
                  >
                    Report a Problem
                  </a>
                  <hr style={{ margin: 0 }} />
                  <button
                    style={{ ...dropdownItemStyle, color: "#e53935" }}
                    onClick={() => {
                      setProfileDropdownOpen(false);
                      logoutToggle();
                    }}
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>


          <Collapse navbar isOpen={collapseOpen} className="d-lg-flex">
            <div className="navbar-collapse-header d-lg-none">
              <Row>
                {logo ? (
                  <Col className="collapse-brand" xs="6">
                    {logo.innerLink ? (
                      <Link to="https://fans-help-players-athlete.web.app/">
                        <img alt={logo.imgAlt} src={Logo} />
                      </Link>
                    ) : (
                      <a href="https://fans-help-players-athlete.web.app/">
                        <img alt={logo.imgAlt} src={Logo} />
                      </a>
                    )}
                  </Col>
                ) : null}
                <Col className="collapse-close" xs="6">
                  <button
                    className="navbar-toggler"
                    type="button"
                    onClick={toggleCollapse}
                  >
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
            <Nav navbar>{createLinks(routes)}</Nav>
            {!isManager && (
              <Nav className="mb-md-3" navbar>
                <NavItem className="nav-bottom mt-2 mt-md-0">
                  <NavLink>
                    <Link
                      to={{
                        pathname: `/terms-and-conditions`,
                        search: "?" + `admin`,
                      }}
                      style={{
                        textDecoration: "none",
                        color: "inherit",
                        fontWeight: "bold",
                      }}
                    >
                      Terms & Conditions
                    </Link>
                  </NavLink>
                </NavItem>
              </Nav>
            )}
          </Collapse>
        </Container>
      </Navbar>

      {/* Logout modal */}
      <Modal isOpen={logoutModal} centered toggle={logoutToggle}>
        <ModalBody>
          <div className="text-center">
            <i
              className="fa fa-sign-out-alt text-primary"
              style={{ fontSize: 70 }}
            ></i>
            <br /><br />
            <span className="mt-5" style={{ fontSize: 30 }}>Are you sure?</span>
            <br /><br />
            <span className="mt-5" style={{ fontSize: 16 }}>You want to logout.</span>
            <br /><br /><br />
            <Button color="danger" onClick={logoutToggle}>Cancel</Button>{" "}
            <Button color="primary" onClick={() => dispatch(logout())}>Logout</Button>
          </div>
        </ModalBody>
      </Modal>

      <AthletePromotionModal
        isOpen={selfBoostModal}
        onClose={toggleSelfBoostModal}
        athlete={{
          id: uid,
          name:
            user?.name ||
            `${user?.first_name || ""} ${user?.last_name || ""}`.trim() ||
            "Your Name",
          email: user?.email || "",
          sport: user?.sport || "",
          profileImage: user?.photo || user?.photoURL,
        }}
        type="selfBoost"
      />
    </>
  );
};

const dropdownItemStyle = {
  display: "block",
  width: "100%",
  padding: "10px 16px",
  background: "none",
  border: "none",
  textAlign: "left",
  fontSize: "14px",
  cursor: "pointer",
  color: "#333",
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    innerLink: PropTypes.string,
    outterLink: PropTypes.string,
    imgSrc: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
